"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = require("../utils/collection");
var utils_1 = require("./utils");
var AppHydration = /** @class */ (function () {
    function AppHydration(hydrationKey) {
        this.hydrationKey = hydrationKey;
    }
    AppHydration.prototype.getAppHydration = function (manifest, appParamsHelper) {
        var hydrationId = utils_1.getAppKey(manifest, appParamsHelper);
        var hydrationPoint = this.getHydrationPoint();
        return (hydrationPoint &&
            hydrationPoint.appsByKey &&
            hydrationPoint.appsByKey[hydrationId]);
    };
    AppHydration.prototype.getManagerHydration = function () {
        var hydrationPoint = this.getHydrationPoint();
        return hydrationPoint && hydrationPoint.manager;
    };
    AppHydration.prototype.mergeAppsResponses = function (appsResponses) {
        var javascriptPieces = [];
        if (appsResponses && appsResponses.length > 0) {
            var merged_1 = { apps: [] };
            var appsHash_1 = new Map();
            var translationHash_1 = new Map();
            for (var _i = 0, appsResponses_1 = appsResponses; _i < appsResponses_1.length; _i++) {
                var appsResponse = appsResponses_1[_i];
                var apps = appsResponse.apps, manager = appsResponse.manager, translations = appsResponse.translations, javascript = appsResponse.javascript;
                if (manager && typeof manager === 'object' && Object.keys(manager).length > 0) {
                    merged_1.manager = manager;
                }
                if (apps && merged_1.apps) {
                    apps.forEach(function (app) {
                        var key = app.app.applicationCode + "_" + app.app.id;
                        if (!appsHash_1.has(key)) {
                            appsHash_1.set(key, true);
                            merged_1.apps.push(app);
                        }
                    });
                }
                if (translations) {
                    if (!merged_1.translations) {
                        merged_1.translations = [];
                    }
                    translations.forEach(function (translation) {
                        var key = translation.phrase + "_" + translation.culture + "_" + translation.translationCulture;
                        if (!translationHash_1.has(key)) {
                            translationHash_1.set(key, true);
                            merged_1.translations.push(translation);
                        }
                    });
                }
                if (javascript) {
                    javascriptPieces.push(javascript);
                }
            }
            if (javascriptPieces && javascriptPieces.length > 0) {
                merged_1.javascript = javascriptPieces.join('\n');
            }
            return merged_1;
        }
        return;
    };
    AppHydration.prototype.setHydrationPoint = function (appsResponse) {
        var hydrationPoint = this.getHydrationPoint();
        if (!hydrationPoint) {
            hydrationPoint = {
                appsByKey: {},
            };
        }
        var mergedAppsResponse = this.mergeAppsResponses([hydrationPoint, appsResponse]);
        hydrationPoint = __assign(__assign({}, mergedAppsResponse), { appsByKey: __assign(__assign({}, collection_1.pivotCollection(mergedAppsResponse.apps || [], function (appResponse) { return appResponse.app.id || 'NO_ID'; })), collection_1.pivotCollection(mergedAppsResponse.apps || [], function (appResponse) { return appResponse.app.id + "|" + appResponse.app.applicationCode; })) });
        window[this.hydrationKey] = hydrationPoint;
    };
    AppHydration.prototype.getHydrationPoint = function () {
        if (!window[this.hydrationKey]) {
            window[this.hydrationKey] = {};
        }
        return window[this.hydrationKey];
    };
    return AppHydration;
}());
exports.AppHydration = AppHydration;
//# sourceMappingURL=AppHydration.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/appsManager/AppHydration.js
// module id = 630
// module chunks = 1